import { Editor } from '@tiptap/core';

/**
 * Push externally-loaded content into the editor without making it undoable.
 *
 * The editor mounts before the task detail has loaded, so it starts on an empty
 * document and the real description arrives afterwards through the `value`
 * prop. A plain `setContent` puts that load on the undo stack, so the first
 * Cmd/Ctrl+Z after opening a task undoes the load and leaves the description
 * empty - and the debounced autosave then persists the empty document (#3140).
 *
 * `addToHistory: false` keeps the load out of the history plugin, so there is
 * nothing to undo until the user actually edits something. The user's own
 * edits are ordinary transactions and stay fully undoable.
 *
 * Chained commands share one transaction, so the meta set here applies to the
 * `setContent` that follows it.
 */
export function applyExternalContent(editor: Editor, html: string) {
  if (html === editor.getHTML()) {
    return;
  }

  editor
    .chain()
    .setMeta('addToHistory', false)
    .setContent(html || '')
    .run();
}
